<template>
  <el-container>
    <el-aside width="-">
      <!--左侧工作区-->
      <el-col :span="24">
        <leftMenu activeIndex='9'></leftMenu>
      </el-col>
    </el-aside>
    <el-aside width="360px">
      <div class="chat_container">
        <div class="chat_title">
          <div class="chat_head">
            <div class="title">弈Chat</div>
            <div class="desc">你的智能财经内容问答助手～</div>
          </div>
        </div>
        <el-col :span="22" :offset="1">
          <el-button style="width: 100%;" type="primary" @click="createSession">新建对话</el-button>
          <div class="t_l" style="font-weight: bolder;padding:10px 0px ;font-size: 14px;margin-top: 20px;">历史对话</div>
          <div class="sessionList" v-infinite-scroll="getSessions" :infinite-scroll-immediate="true"
            :infinite-scroll-disabled='sessionsFinish'>
            <el-radio v-for="item in sessions" :key="item.id" v-model="sessionId" :label="item.id" border>
              <div class="sessionItem">
                <div style="font-size: 12px;color: #999999;margin-bottom: 10px;">{{ item.addTime }}</div>
                <div class="title">&nbsp;&nbsp;{{ item.chatTitle }}</div>
              </div>
            </el-radio>
          </div>
          <div v-if="!sessions || sessions.length === 0" class="sessionEmpty"></div>
        </el-col>
      </div>
      <!--左侧工作区-->

    </el-aside>
    <el-main class="work_container " style="overflow:auto">

      <div style="">
        <!-- 热搜榜单 -->
        <el-row>
          <el-col :span="24" :offset="0">
            <div class="chat_container" style="    padding-right: 20px;
    box-sizing: border-box;display: flex;
    flex-direction: column;">

              <div class="chat_list" ref="chat_list">
                <div style="height: 0px;display: block;"> <el-link v-if="hasMore" type="primary" style="z-index: 99999;"
                    @click="loadMongQuestion">查看更多内容</el-link>
                </div>

                <div v-for="(item) in chatList" :key="item.id" :ref="item.id">
                  <div class="right_chat_container" v-if="item.userQuestion">
                    <span class="right_chat">
                      {{ item.userQuestion }}
                    </span>
                    <el-avatar class="right_avatar" :size="30"
                      :src="userInfo.headPath || './static/imgs/defaultAvatar.png'">
                    </el-avatar>
                  </div>
                  <div v-for="(answer, ai) in item.sysAnswers" :key="ai" class="left_chat_container">
                    <span class=" left_chat">

                      <span v-if="answer.showType === 'link'">
                        <iframe :name="answer.id" :title="answer.id" :src="answer.content"
                          style="width: 577px;border: none;height: 500px;"></iframe>
                      </span>
                      <span v-else-if="answer.showType === 'subassembly'">
                        <template v-if="answer.answerType !== 'csmar_news'">
                          <Kline v-if="answer.content.type === 'kline'" :resdata="answer.content" :isCard="true">
                          </Kline>
                          <MLine v-if="answer.content.type === 'mline'" :resdata="answer.content" :isCard="true">
                          </MLine>
                        </template>
                        <template v-else>
                          <news :content="answer.content" />
                        </template>

                      </span>
                      <span v-else v-html="answer.content">
                      </span>

                      <div v-if="answer.describeAnswer">
                        <template v-if="showDescribMap[answer.id]">
                          <div class="describeContainer" v-for="(item, index) in JSON.parse(answer.describeAnswer) "
                            :key="index">
                            <span> {{ item.FieldName }}</span> :<span v-if="item.Type === 0">{{ item.Fielddescribe
                              }}</span>

                            <el-link v-if="item.Type === 1" :underline="false"
                              @click="openPdf(item.Fielddescribe)"><span>
                                {{ item.Fielddescribe }}</span></el-link>
                          </div>
                        </template>

                      </div>
                      <div class="answerOptContainer" v-if="setOptAnswer(answer) && sessionId !== -1">
                        <el-link v-if="answer.describeAnswer" style="flex-grow: 0;" type="primary" :underline=false
                          @click="changeDescrib(answer.id)"><template
                            v-if="showDescribMap[answer.id]">收起数据字段注释</template><template
                            v-else>查看数据字段注释</template></el-link>
                        <span style="flex-grow: 1;"></span>
                        <el-link :underline="false" :type="optMap[answer.id].vote === '有用' ? 'primary' : ''"
                          @click="vote(item.id, answer.id, optMap[answer.id].vote === '有用' ? '未选中' : '有用')"><i
                            class="iconfont_yx">&#xe60b;</i></el-link>
                        &nbsp;
                        <el-link style="flex-grow: 0;" :underline="false"
                          :type="optMap[answer.id].vote === '没用' ? 'primary' : ''"
                          @click="vote(item.id, answer.id, optMap[answer.id].vote === '没用' ? '未选中' : '没用')"><i
                            class="iconfont_yx">&#xe609;</i></el-link>
                        &nbsp;
                        <el-link style="flex-grow: 0;" :underline="false"
                          :type="optMap[answer.id].addMyMaterial ? 'primary' : ''"
                          :disabled="(optMap[answer.id].showType === 'subassembly') || optMap[answer.id].addMyMaterial"
                          @click="addMyMaterial(item.id, answer.id)"> <i class="iconfont_yx">&#xe608;</i></el-link>
                        &nbsp; <div :class="answer.answerType + ' answer_source'"></div> &nbsp;
                      </div>
                    </span>
                  </div>
                </div>

              </div>
              <div class="tip_container">
                <div v-show="addSuccess" class="addSuccess"><i class="iconfont_yx">&#xe63d;</i>已添加到素材库</div>
                <el-tag v-if="asking">小弈正在思考...</el-tag>
                <div class="notVip" v-if="!isGoldVip"></div>
              </div>
              <div class="char_foot">

                <template v-if="(relationDataList && relationDataList.length > 0) || (asks && asks.length > 0)">
                  <div class="backBtnContainer">
                    <a href="javascript:void(0)"
                      style="width: 24px;height: 24px;display: inline-block; position: absolute;top: 0px;right: 0px;z-index: 9;">
                      <div class="backBtn" @click="relationDataBack"></div>
                    </a>
                  </div>

                  <el-tabs v-model="askTab">
                    <el-tab-pane v-if="relationData && relationData.data" :label="relationData.title"
                      :name="relationData.title">
                      <div style="display: flex;">
                        <el-link :underline=false style="margin-right: 10px;color:#000"
                          @click="sendQuestion(item.name, true)" v-for="(item) in  relationData.data" :key="item.id">
                          <div class="ralationBtn">
                            <div class="name"> {{ item.name }}</div>
                            <div class="change"
                              :style="parseFloat(item.change) > 0 ? 'color:red' : parseFloat(item.change) < 0 ? 'color:green' : 'color:black'">
                              {{ item.change }}</div>
                          </div>
                        </el-link>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="推荐问题" name="推荐问题" v-if="asks && asks.length > 0">
                      <div class="ask_container">
                        <el-link style="margin-right: 30px;color:#000" :underline=false @click="sendQuikQuestion(item)"
                          v-for="(item, index) in asks" :key="index">
                          <div class="ralationBtn" style="width: auto;">
                            <div class="name"> {{ item }}</div>
                          </div>
                        </el-link>
                      </div>
                    </el-tab-pane>
                  </el-tabs>

                </template>
                <template v-else>
                  <div class="echart_title">
                    聊财经，找小弈，你想了解什么
                  </div>
                  <div style="display: flex;">
                    <el-link style="margin-right: 10px;color:#000" :underline=false
                      @click="sendQuestion(item.name, true)" v-for="(item, index) in  sessionTags" :key="index">
                      <div class="ralationBtn">
                        <div class="name"> {{ item.name }}</div>
                      </div>
                    </el-link>
                  </div>
                </template>
                <el-row class="askContainer">
                  <el-form ref="formRef" :model="chatForm" label-width="100px" action="javascript:void(0)">
                    <el-col :span="20">
                      <el-input v-model="chatForm.question" :rows="2" type="text" show-word-limit maxlength="100"
                        class="input_question" placeholder="聊财经，找小弈～您可以问我：海康威视这只股票怎么样？" />
                    </el-col>
                    <el-col :span="4" style="text-align: right;padding-right: 20px;">
                      <el-button type="primary" @click="sendQuestion()" round native-type="submit"
                        :disabled="!isGoldVip">
                        &nbsp;发 &nbsp;送
                        &nbsp;</el-button>&nbsp;
                    </el-col>
                  </el-form>
                </el-row>

              </div>

            </div>

          </el-col>
        </el-row>
      </div>
    </el-main>

    <el-dialog width="500" top="0" :visible.sync="pdfDialogVisible">
      <iframe title="注释预览" :src="pdfUrl" style="width: 100%;height: calc(100vh - 140px);border: 0;" />
    </el-dialog>

  </el-container>
</template>

<script>
import leftMenu from '../components/left_menu'
import Kline from '../components/chart/KLine/index.vue'
import MLine from '../components/chart/MLine/index.vue'
import news from '../components/chart/news.vue'

import lastStockPriceForecastVue from '../components/chart/yty_model/lastStockPriceForecast.vue'
import historyOfShareOutBonus from '../components/chart/yty_model/historyOfShareOutBonus.vue'
// import * as appJs from '../assets/js/app'

// import Loading from '../components/js/Loading'
export default {
  name: 'index',
  data: function () {
    return {
      chatForm: {
        question: ''
      },
      page: 1,
      userInfo: {},
      chatList: [],
      hasMore: false,
      asking: false,
      addSuccess: false,
      optMap: {},
      timer: null,
      asks: [],
      isGoldVip: true,
      sessions: [],
      sessionTags: {},
      sessionId: 0,
      lastSessionId: -1,
      sessionsFinish: false,
      firstQuetion: {},
      relationData: {},
      relationDataList: [],
      askTab: '推荐问题',
      showDescribMap: {},
      pdfUrl: '',
      pdfDialogVisible: false

    }
  },

  methods: {
    setOptAnswer (answer) {
      this.optMap[answer.id] = answer
      return true
    },
    openPdf (url) {
      this.pdfUrl = url
      this.pdfDialogVisible = true
    },
    changeDescrib (id) {
      console.log(id)
      this.showDescribMap[id] = !this.showDescribMap[id]
      this.$forceUpdate()
    },
    relationDataBack () {
      this.relationDataList = this.relationDataList.slice(0, -1)
      this.relationData = this.relationDataList.slice(-1)[0]
      this.asks = []
    },
    getFirstQuestion () {
      this.axios.get('/webApi/v3/chat/chatFirstSentence').then(resp => {
        this.firstQuetion = resp.data
      })
    },
    createSession () {
      this.axios.get('/webApi/v3/chat/newDialog').then(resp => {
        if (!this.sessions || this.sessions.length === 0 || this.sessions[0].id > 0) {
          this.sessions.unshift({ 'addTime': '', 'chatTitle': '新建会话', 'id': -1 })
          this.$message({
            type: 'success',
            message: '会话创建成功'
          })
        }
        this.relationData = {}
        this.relationDataList = []
        this.asks = []
        this.sessionId = -1
      })
    },
    getSessions () {
      this.axios.get(`/webApi/v3/chat/dialogListById?dialogId=${this.lastSessionId}`).then(resp => {
        this.sessionsFinish = false
        if (!resp.data || resp.data.length === 0) {
          this.sessionsFinish = true
          return
        }
        this.sessions = this.sessions.concat(resp.data)
        if (this.sessions && this.sessions[0]) {
          this.lastSessionId = this.sessions.slice(-1)[0].id
        }
      })
    },
    getSessionTags () {
      this.axios.get('/webApi/v3/chat/chatRegions').then(resp => {
        this.sessionTags = resp.data
      })
    },
    addMyMaterial (recordId, answerId) {
      let _this = this
      this.optMap[answerId].addMyMaterial = true
      this.axios.post('/webApi/v3/material/addMyMaterial', { '$noLoading': true, 'answerId': answerId, 'recordId': recordId }).then(resp => {
        _this.addSuccess = true

        if (_this.timer) {
          clearTimeout(_this.timer)
        }
        _this.timer = setTimeout(function () {
          _this.addSuccess = false
        }, 3000)
      })
    },

    vote (recordId, answerId, vote) {
      let _this = this
      this.optMap[answerId].vote = vote
      this.axios.post('/webApi/v3/chat/vote', { '$noLoading': true, 'answerId': answerId, 'vote': vote, 'recordId': recordId }).then(resp => {
        _this.$forceUpdate();
      })
    },
    getUserInfo () {
      let _this = this
      this.axios.get('/webApi/v3/user/userInfo').then(resp => {
        _this.userInfo = resp.data
        localStorage.setItem('userInfo', JSON.stringify(resp.data))
      })
    },
    getCurrentSessionId () {
      let _this = this
      this.axios.get('/webApi/v3/chat/currentDialogId').then(resp => {
        if (resp.data) {
          _this.sessionId = resp.data
        } else {
          _this.sessionId = -1
        }
      })
    },

    loadMongQuestion () {
      this.page++
      this.questionHistory()
    },
    questionHistory () {
      let _this = this
      let _target;
      if (this.chatList[0]) {
        _target = this.$refs[this.chatList[0].id]
      }
      this.axios.get(`/webApi/v3/chat/dialogChatRecordList?page=${this.page}&dialogId=${this.sessionId}`).then(resp => {
        _this.asking = false
        if (resp && resp.data) {
          if (_this.page === 1) {
            _this.chatList = []
          }
          _this.hasMore = parseInt(resp.data.pages) > parseInt(resp.data.current)
          _this.chatList = resp.data.records.concat(_this.chatList)
          if (_this.page === 1) {
            _this.scrollToEnd()
          } else {
            if (_target) {
              this.$nextTick(function () {
                _target[0].scrollIntoView({
                  block: 'start'
                })
              })
            }
          }
        }
      })
    },
    sendQuikQuestion (question) {
      this.sendQuestion(question)
    },
    sendQuestion (question, addHistory) {
      if (!question) {
        question = this.chatForm.question
      }
      if (!question) {
        this.$message.error('请输入内容');
        return
      }

      let _this = this
      _this.asking = true
      _this.chatList.push({ 'userQuestion': question })
      _this.scrollToEnd()
      _this.chatForm.question = ''

      this.axios.post('/webApi/v3/chat/ask', { 'question': question, '$noLoading': true }).then(resp => {
        _this.page = 1
        _this.chatList = _this.chatList.slice(0, -1)
        _this.chatList.push(resp.data)
        _this.chatForm.question = ''
        _this.asking = false
        _this.scrollToEnd()
        _this.$nextTick(() => {
          _this.asks = resp.data.randomAsks
          if (_this.asks.length > 0) {
            _this.askTab = '推荐问题'
          }
          if (addHistory) {
            _this.relationData = resp.data.relationData
            _this.relationDataList.push(_this.relationData)
          }
        })

        if (_this.sessionId === -1) {
          _this.sessionId = resp.data.dialogId
          _this.lastSessionId = -1
          _this.sessions = []
          _this.getSessions()
        }
      })
    },
    scrollToEnd () {
      let _this = this
      setTimeout(function () {
        if (_this.$refs['chat_list']) {
          _this.$refs['chat_list'].scrollTop = 100000000000
        }
      }, 100)
    }
  },
  components: {
    Kline,
    MLine,
    leftMenu,
    lastStockPriceForecastVue,
    historyOfShareOutBonus,
    news
  },
  watch: {
    sessionId: function () {
      console.log(this.sessionId)
      this.chatList = []
      this.page = 1
      if (this.sessionId === -1) {
        if (this.firstQuetion.moduleHtml) {
          let sysAnswers = [{ 'content': this.firstQuetion.moduleHtml }]
          this.chatList.push({ 'sysAnswers': sysAnswers })
        }
      } else {
        this.questionHistory()
      }
    },
    firstQuetion: function () {
      console.log('firstQuetion')
      if (this.sessionId === -1 && this.chatList.length === 0) {
        let sysAnswers = [{ 'content': this.firstQuetion.moduleHtml }]
        this.chatList.push({ 'sysAnswers': sysAnswers })
      }
    }
  },
  mounted () {
    window.setAnswer = (answer) => {
      this.sendQuestion(answer)
    }
    this.getUserInfo()
    this.getFirstQuestion()
    this.getSessionTags()
    this.getCurrentSessionId()
    // appJs.isGoldVip().then((isGoldVip) => {
    //   this.isGoldVip = true
    //   if (isGoldVip) {
    //     this.questionHistory()
    //   }
    // })
  }
}
</script>
<style lang="less" scoped>
.work_container {
  padding: 0px;
}

.describeContainer {
  font-size: 12px;

  span {
    vertical-align: middle;
  }
}

.echart_title {
  vertical-align: middle;
  margin-bottom: 10px;
}

.echart_title::before {
  content: ' ';
  background-image: url('../assets/imgs/chat/chart_title_icon.png');
  width: 24px;
  height: 24px;
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  vertical-align: middle;
}

.ralationBtn {
  width: 145.45px;
  vertical-align: middle;
  display: table-cell;
  height: 60px;
  opacity: 1;
  border-radius: 8px;
  background: rgba(246, 249, 253, 1);
  box-shadow: 0px 1.39px 33.44px rgba(0, 0, 0, 0.04);
  text-align: center;

  padding: 0px 10px;
}

.ralationBtn:hover {
  background: linear-gradient(270deg,
      rgba(107, 255, 161, 0.6) 0%,
      rgba(71, 192, 252, 0.6) 100%);

  .name {
    font-weight: bold;
  }
}

.sessionList::-webkit-scrollbar {
  width: 5px;
  height: 100px;
  background-color: white;
}

.sessionList::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30px;
  background-color: #e3eaff;
  border-radius: 5px;
}

.sessionList {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  text-align: left;

  .sessionItem {
    padding-left: 20px;
    padding-top: 10px;
    margin: auto;
    margin-bottom: 2px;

    width: 92%;
    height: 71px;
    opacity: 1;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 8px 10px 4px rgba(184, 184, 210, 0.2);

    .title {
      word-break: break-all;
      max-width: 96%;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }

    .title::before {
      content: ' ';
      background-image: url('../assets/imgs/session_icon.png');
      width: 35px;
      height: 35px;
      display: inline-block;
      vertical-align: middle;
      background-size: contain;
    }
  }
}

.sessionEmpty {
  width: 150px;
  height: 150px;
  background-image: url('../assets/imgs/sessionEmpty.png');
  margin: auto;
  top: calc(30vh - 100px);
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;
}

.sessionEmpty::after {
  content: '快和弈Chat聊聊财经吧～';
  position: relative;
  display: block;
  bottom: -126px;
  width: 160px;
  font-size: 12px;
  margin: auto;
  text-align: center;
  color: #8b8ba7;
}

.chat_container {
  width: 100%;
  // position: absolute;
  height: 100vh;
  // // height: calc(100vh - 200px);
  // top: 100px;
  box-shadow: 0px 0px 15px 5px #eee;
  background-color: #fff;
  border-radius: 8px;
  // min-width: 880px;
  margin: auto;
  overflow: hidden;
  letter-spacing: 2px;

  .answerOptContainer {
    text-align: right;
    height: 20px;
    display: flex;
    margin-top: 10px;
  }

  .iconfont_yx {
    font-size: 18px;
  }

  .answer_source {
    display: inline-block;
    width: 20px;
    height: 20px;
  }

  .answer_source::after {
    color: #a6a6a6;
    font-size: 12px;
    border: 1px solid rgba(102, 102, 102, 1);
    border-radius: 3px;
    display: inline-block;
    height: 14px;
    width: 20px;
    text-align: center;
  }

  .csmar_table::after {
    content: '1';
  }

  .csmar_news::after {
    content: '10';
  }

  .csmar_kg::after {
    content: '9';
  }

  .csmar_quote::after {
    content: '3';
  }

  .csmar_glm::after {
    content: '2';
  }

  .csmar_link::after {
    content: '4';
  }

  .csmar::after {
    content: '5';
  }

  .yuntianyi::after {
    content: '6';
  }

  .yty_module::after {
    content: '6';
  }

  .yty_prefix::after {
    content: '6';
  }

  .csmar_hyw::after {
    content: '10';
  }

  .csmar_hym::after {
    content: '11';
  }

  .simple::after {
    content: '7';
  }

  .miss {
    width: 0px !important;
  }

  .miss::after {
    content: ' ';
    width: 0px;
  }

  .chat_title {
    background-image: url('../assets/imgs/chat/head_bg.png');
    background-size: 100% 100%;
    width: 100%;
    height: 80px;
    position: relative;

    .chat_head {
      background-image: url('../assets/imgs/chat/chat_icon.png');
      background-size: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      height: 50px;
      margin: 10px;
      position: absolute;
      padding-left: 60px;
      text-align: left;

      .title {
        font-weight: bolder;
        padding: 4px 0px;
      }

      .desc {
        font-size: 12px;
        color: #2e2f30;
      }
    }

    .chat_computer {
      background-image: url('../assets/imgs/chat/chat_computer.png');
      background-size: 100% 100%;
      width: 85px;
      height: 60px;
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }

  .tip_container {
    margin-top: 10px;
    height: 1px;
    bottom: 12px;
    position: relative;

    .notVip {
      background-image: url('../assets/imgs/chatNoVip.png');
      width: 300px;
      height: 166px;
      right: 32px;
      top: -143px;
      position: absolute;
    }

    .addSuccess {
      color: #fff;
      width: 148px;
      margin: auto;
      border-radius: 20px;
      padding: 3px;
      font-size: 14px;
      background-color: #a5d63f;
      top: -15px;
      position: relative;
    }
  }

  .chat_list::-webkit-scrollbar {
    width: 5px;
    height: 100px;
    background-color: white;
  }

  .chat_list::-webkit-scrollbar-thumb {
    width: 5px;
    height: 30px;
    background-color: #e3eaff;
    border-radius: 5px;
  }

  .chat_list {
    background-color: #fff;
    width: 100%;
    overflow-y: auto;
    height: calc(100vh - 230px);
    position: relative;
    padding-top: 10px;

    .right_chat_container {
      text-align: right;
      margin: 10px 10px;
      margin-top: 0px;
      position: relative;
      max-width: 98%;

      .right_avatar {
        position: absolute;
        top: 0px;
        right: 0px;
      }

      .right_chat {
        background-color: #578fff;
        border-radius: 15px;
        border-top-right-radius: 0px;
        color: white;
        padding: 10px;
        margin-right: 40px;
        max-width: 400px;
        display: inline-block;
        text-align: left;
      }
    }

    .left_chat_container {
      text-align: left;
      margin: 10px 10px;
      position: relative;

      .left_chat::after {
        // border: 1px solid red;
        // width: 14px;
        // height: 14px;
        // border-radius: 3px;
      }

      .left_chat {
        background-color: #f1f5fd;
        border-radius: 15px;
        border-top-left-radius: 0px;
        padding: 10px;
        margin-left: 40px;
        max-width: calc(100vw - 700px);
        text-align: left;
        display: inline-block;
        position: relative;
        word-break: break-all;
        overflow-x: auto;

        span {
          max-width: calc(100vw - 520px);
          overflow-x: auto;
          display: inline-block;
        }

        span::-webkit-scrollbar {
          width: 100px;
          height: 5px;
          background-color: white;
        }

        span::-webkit-scrollbar-thumb {
          width: 5px;
          height: 30px;
          background-color: #e3eaff;
          border-radius: 5px;
        }

        .opt_container {
          height: 0px;
          width: 0px;
          position: absolute;
          right: -6px;
          bottom: 17px;
          color: #718aff;
        }
      }
    }

    .left_chat_container::before {
      content: ' ';
      width: 30px;
      height: 30px;
      background-image: url('../assets/imgs/chat/chat_icon.png');
      display: inline-block;
      background-size: 100%;
      position: absolute;
    }
  }

  .char_foot {
    margin: 12px;
    text-align: left;
    padding-left: 20px;

    .askContainer {
      padding: 10px;
      border: 1px solid #459df4;
      border-radius: 10px;
      margin-top: 10px;
    }

    .backBtnContainer {
      position: relative;
      height: 0px;

      .backBtn {
        content: ' ';
        background-image: url('../assets/imgs/chat/back.png');
        width: 20px;
        height: 20px;
        display: inline-block;
        position: absolute;
        top: 10px;
        right: 0px;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>

<style lang="less">
.sessionList {
  .el-radio {
    height: auto !important;
    padding: 0px;
    width: 100%;
    border: none;
    margin: 0px !important;

    .el-radio__input {
      display: none;
    }
  }
}

.input_question {
  .el-input__inner {
    background-color: #fff;
    border-radius: 20px;
    padding-right: 60px;
    border: none;
  }

  .el-input__count-inner {
    background: none !important;
  }
}

.chat_opt_container {
  min-width: 0px !important;

  .is-checked {
    .el-checkbox-button__inner {
      border: none !important;
      background-color: #e2e5ee !important;
      color: black;
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/chat.vue